import { DEFAULT_SANITIZE_OPTIONS } from '../helpers/compilerHelper';

export const DEFAULT_OPTIONS = {
  filterHTML: false,
  term: {
    compile: false,
    highlight: false,
    component: null,
  },
  markedText: {
    compile: false,
    modes: null,
    component: null,
  },
  sanitizeOptions: DEFAULT_SANITIZE_OPTIONS,
};

export const useCompiler = (options = DEFAULT_OPTIONS) => {
  const term = { ...DEFAULT_OPTIONS.term, ...(options?.term || {}) };
  const markedText = { ...DEFAULT_OPTIONS.markedText, ...(options?.markedText || {}) };

  return {
    filterHTML: options?.filterHTML ?? DEFAULT_OPTIONS.filterHTML,
    term,
    markedText,
    sanitizeOptions: options?.sanitizeOptions ?? DEFAULT_SANITIZE_OPTIONS,
  };
};

export default useCompiler;
